import { createSelector, Selector } from '@reduxjs/toolkit';

import { RootState } from '~/store';

import { UserState } from '.';

const selectSelf: Selector<RootState, UserState> = state => state.user;

export const selectIsUserAuthenticated = createSelector(selectSelf, state => !!state.tokens);

export const selectUser = createSelector(selectSelf, state => state.profile);

export const selectUserRole = createSelector(selectUser, state => state?.role);
